export default "__VITE_ASSET__cAlER8JU__"